// extracted by mini-css-extract-plugin
export default {"block":"aFcGl","alignXLeft":"bFcGl","alignXCenter":"cFcGl","alignXRight":"dFcGl","alignYTop":"eFcGl","alignYCenter":"fFcGl","alignYBottom":"gFcGl"};